import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "../../../components/Modal";
import { formatDate, formatToZMW, rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import AddBillModal from "./addBill";
import { useOutletContext } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { FaEye, FaFile, FaList, FaPlus, FaSpinner } from "react-icons/fa";
import { collapse } from "@material-tailwind/react";
import FormGenerator from "../../../components/formGenerator";
import { toast } from "react-toastify";
import { FaFileLines } from "react-icons/fa6";

const Bills = () => {
  const [bills, setBills] = useState([]);
  const [recs, setRecs] = useState([]);
  const [showBillModal, setShowBillModal] = useState(false);
  const [showAddBillModal, setShowAddBillModal] = useState(false);
  const [selectedBill, setSelectedBill] = useState([]);
  const [statement, setStatement] = useState([]);
  const [makePayment, setMakePayment] = useState(false);

  const auth = useAuth();
  // const { dept, coa ,program ,subProgram, bank, cc, sof  } = useOutletContext();
  const allData = useOutletContext();

  // Fetch Bill
  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const response = await axios.get(rootUrl(`/bills/${auth.user.id}`));
      setBills(response.data.data);
    
    } catch (error) {
      console.error("Error fetching bills:", error);
    }
  };



  const handleViewBill = async (billId) => {
    try {
      const response = await axios.get(rootUrl(`/bill/${billId}`));
      setSelectedBill(response.data.bills);
      setRecs(response.data.recs);
      setShowBillModal(true);


      const billz = response.data.bills.map((bill) => ({
        ...bill,
        type: "Bill",
        date: new Date(bill.date),
      }));
  
      const receipts = response.data.recs.map((rec) => ({
        ...rec,
        type: "Receipt",
        date: new Date(rec.date),
      }));
  
      // Merge and sort by date
      const combined = [...billz, ...receipts].sort((a, b) => a.date - b.date);
      setStatement(combined);

    } catch (error) {
      console.error("Error fetching bill details:", error);
    }
  };

  const handleAddBill = () => {
    setShowAddBillModal(true);
  };

  const totalOutstanding = bills.reduce((sum, row) => sum + parseFloat(row.amount), 0);

  const columns = [
    {
        name: "Sn",
        selector: (row, index) => index + 1,
        sortable: true,
        width: "50px",
    },
    {
      name: "Bill Date",
      selector: (row) =>formatDate(row.date.substring(0,10)),
      sortable: true,
  },
    {
        name: "Bill No",
        selector: (row) => row.invoice_no,
        sortable: true,
    },
    {
        name: "Customer",
        selector: (row) => `${row.firstname} ${row.lastname}`,
        sortable: true,
    },
    {
        name: "Outstanding",
        selector: (row) => formatToZMW(row.amount),
        sortable: true,
    },
    {
        name: "Actions",
        cell: (row) => (
            <button
                onClick={() => handleViewBill(row.id)}
                className="bg-blue-900 hover:bg-blue-900 text-white px-3 py-1 rounded"
            >
                <FaEye/>
            </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
];

const fields = [
  {type: 'select', name: 'billID', label: 'Bill', required: true, options:
    selectedBill.map((res)=>({
      value:res.b_id,
      label:`${allData.budget?.find(a=>a.id === res.coa_id)?.coa}`
    }))
  },
  {type: 'select', name: 'type', label: 'Type', required: true, options:[
    {value:1, label:'Payment'},
    {value:2, label:'Credit note'},
  ]},
  {type: 'text', name: 'amount', label: 'Amount', required: true},
  {type: 'text', name: 'description', label: 'Description', required: true},
]

const onsubmit = async (formdata)=>{

  formdata['uid'] = auth.user.id
  try{

    const response = await axios.post(rootUrl('/addPayment'), formdata)

    if(response.data.status === 200){
      toast.success("Submitted successfully")
      setMakePayment(false)
      handleViewBill(selectedBill[0].b_id)
    }else{
      toast.error("Something went wrong")
    }


  }catch(e){
    toast.error(e?.message)
  }

}

const handleFormSubmit = async (payload) => {
  
  payload['uid'] = auth.user.id
  try{
      const response = await axios.post(rootUrl('/addBill'), payload)
      if(response.data.status === 200){
          toast.success("Submitted successfully")
          setShowAddBillModal(false)
          fetchBills()
      }else{
          toast.error("Something went wrong")
      }

  }catch(e){
      toast.error(e?.message)
  }
};


  return (
    <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="text-[25px] text-slate-800 font-bold">Bills</h1>
          <span className="text-[12px] text-slate-700">All bills listed here</span>
        </div>
        <button
          onClick={handleAddBill}
          className="flex items-center bg-blue-900 text-white justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        >
          <FaPlus/>
          New
        </button>
      </div>

      <hr />
      <DataTable
                title=""
                columns={columns}
                data={bills}
                pagination
                highlightOnHover
                striped
                responsive
            />

<div className="mt-4 text-right font-bold">
        Total Outstanding: {formatToZMW(totalOutstanding)}
      </div>

      {/* View Bill Modal */}
      {showBillModal && (
        <Modal title="View Bill" onClose={() => setShowBillModal(false)}>
          {selectedBill ? (
            <div>
              <h2 className="text-lg font-bold">Customer: {selectedBill[0].firstname} {selectedBill[0].lastname}</h2>
              <p>Invoice No: {selectedBill[0].invoice_no}</p>
              <p>Date: {formatDate(selectedBill[0].date)}</p>
<hr />
              <div className="bg-white overflow-x-auto my-3">
      <h2 className="text-xl font-bold mb-4 flex items-center"> <FaFileLines /> Statement</h2>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="px-4 py-2 bg-blue-900 text-white border">Sno</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">Date</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">COA</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">Description</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">Debit</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">Credit</th>
            <th className="px-4 py-2 bg-blue-900 text-white border">Balance</th>
          </tr>
        </thead>
        <tbody>
  {statement.reduce(
    (acc, item, index) => {
      // Determine if the item is debit (bill) or credit (receipt)
      const isDebit = item.type === "Bill";
      const amount = parseFloat(item.amount);

      // Update cumulative balance
      const newBalance = isDebit
        ? acc.cumulativeBalance + amount
        : acc.cumulativeBalance - amount;

      // Push the current row with updated values
      acc.rows.push(
        <tr
          key={index}
          className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
        >
          <td className="px-4 py-2 border">{index + 1}</td>
          <td className="px-4 py-2 border">
            {formatDate(item.date.toISOString().substring(0, 10))}
          </td>
          <td className="px-4 py-2 border">
            
            {/* {item.coa_id} :  */}
            
            {
              isDebit?
              <>
                {allData.budget?.find(a=>a.id === item.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === item.coa_id)?.coa)?.name}
              </>
              :
              <>
                {allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa)?.name}
              </>
            }
            
          </td>
          <td className="px-4 py-2 border">
            
            {item.description || "N/A"}
          </td>
          <td className="px-4 py-2 border">
            {isDebit ? formatToZMW(amount) : ""}
          </td>
          <td className="px-4 py-2 border">
            {!isDebit ? formatToZMW(amount) : ""}
          </td>
          <td className="px-4 py-2 border">
            {formatToZMW(newBalance)}
          </td>
        </tr>
      );

      // Update cumulative balance for the next row
      acc.cumulativeBalance = newBalance;
      return acc;
    },
    { rows: [], cumulativeBalance: 0 } // Initial state
  ).rows}
  <tr>
    <th
      className="px-4 py-2 bg-gray-100 border"
      colSpan="6"
      align="right"
    >
      Final Balance
    </th>
    <td className="px-4 py-2 bg-gray-100 border">
      {formatToZMW(
        statement.reduce(
          (sum, item) =>
            item.type === "Bill"
              ? sum + parseFloat(item.amount)
              : sum - parseFloat(item.amount),
          0
        )
      )}
    </td>
  </tr>
</tbody>
      </table>
    </div>

        <div className="mt-5">
          <button className="border rounded p-2 my-2 bg-blue-900 text-white" onClick={()=>setMakePayment(!makePayment)}>Add Payment</button>
          <br/>
          {
            makePayment?
            <><span className="font-bold text-lg">Make Payment</span>
            <hr className="mb-3" />
              <FormGenerator fields={fields} onSubmit={onsubmit} /> </>
            :
            <></>
          }
          
        </div>
      


            </div>
          ) : (
            <p>

          <FaSpinner size={50} className="spinner"  />

            </p>
          )}
        </Modal>
      )}

      {/* Add Bill Modal */}
      {showAddBillModal && (
        <Modal title="Add New Bill" onClose={() => setShowAddBillModal(false)}>
            <AddBillModal data = {allData} onSubmit={handleFormSubmit}/>
        </Modal>
      )}
    </div>
  );
};

export default Bills;
